export const SORT_DIRECTION = { ascending: "asc", descending: "desc" };
export const VALUE_TYPE_MAP = {
  boolean: "boolean",
  dateTime: "dateTime",
  date: "date",
  status: "status"
};
